import { render } from "./modifyNewsDialog.vue?vue&type=template&id=1357f2da&scoped=true"
import script from "./modifyNewsDialog.vue?vue&type=script&lang=js"
export * from "./modifyNewsDialog.vue?vue&type=script&lang=js"

import "./modifyNewsDialog.vue?vue&type=style&index=0&id=1357f2da&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1357f2da"]])

export default __exports__